module.exports = __webpack_public_path__ + "img/cmdb3.0e18def1.png";